// deps
import React, { memo } from "react";

// types
import { ISuccessBanner } from "@dineout-payment-success-ui/interfaces";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// styles
import {
    BillClearedText,
    DividingLine,
    SuccessBannerWrapper,
    TotalAmountText,
    StyledText,
    TickContainer,
    TickImage,
} from "./styles";

// constants
import { BILL_PAYMENT_CONFIRM_TICK, SUCCESS_BANNER_TEXTS } from "@dineout-payment-success-ui/constants/SuccessBanner";

// helpers
import { format } from "@swiggy-private/core-ui";
import { isEmpty } from "@swiggy-private/js-utils";

// test-ids
import { PAYMENT_SUCCESS_BANNER } from "@swiggy-private/payment-test-ids";

const SuccessBanner: React.FC<ISuccessBanner> = ({
    totalAmount,
    paidAmount,
    subscriptionValue,
    tip,
    styles,
}) => {
    return (
        <SuccessBannerWrapper>
            <TickContainer>
                <TickImage cloudinaryId={BILL_PAYMENT_CONFIRM_TICK} />
            </TickContainer>
            <BillClearedText variant="V2.subheading1.neutral.medium" colorCode={styles?.billClearedColor}>
                {SUCCESS_BANNER_TEXTS.BILL_CLEARED}
            </BillClearedText>
            {!isEmpty(totalAmount) && (
                <TotalAmountText
                    variant="V2.hero.neutral.bold"
                    data-testid={PAYMENT_SUCCESS_BANNER.TOTAL_AMOUNT}
                    colorCode={styles?.totalAmountColor}
                >
                    {format(SUCCESS_BANNER_TEXTS.TOTAL_AMOUNT, totalAmount || "")}
                </TotalAmountText>
            )}
            <DividingLine />
            {!isEmpty(paidAmount) && (
                <Text
                    variant="V2.heading2.neutral.black"
                    color="positive"
                    data-testid={PAYMENT_SUCCESS_BANNER.PAID_AMOUNT}
                    style={styles?.paidByYouTextColor ? { color: styles?.paidByYouTextColor } : {}}
                >
                    {format(SUCCESS_BANNER_TEXTS.PAID_AMOUNT, paidAmount || "")}
                </Text>
            )}
            {!isEmpty(tip) && (
                <StyledText
                    variant="V2.body2.neutral.medium"
                    color="text_Med_Emphasis"
                    data-testid={PAYMENT_SUCCESS_BANNER.TIP_TEST_IDS}
                >
                    {format(SUCCESS_BANNER_TEXTS.TIP, `${tip}`)}
                </StyledText>
            )}
            {!isEmpty(subscriptionValue) && (
                <StyledText
                    variant="V2.body2.neutral.medium"
                    color="text_Med_Emphasis"
                    data-testid={PAYMENT_SUCCESS_BANNER.SUBSCRIPTION_VALUE}
                >
                    {format(SUCCESS_BANNER_TEXTS.SUBSCRIPTION, `${subscriptionValue}`)}
                </StyledText>
            )}
        </SuccessBannerWrapper>
    );
};

export default memo(SuccessBanner);
